import { ArrowRight } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import ItemFeatures from '@travel/traveler-core/components/ItemFeatures';
import { parseSearchQuery } from '@travel/traveler-core/utils/jrdpHelper';

import PriceInfo from 'components/PriceInfo';
import Link from 'core/universalRouter/Link';

import styles from '../hotelCard.module.scss';

import type {
  FeatureGroup,
  HasMeal,
  Points,
  RoomCapacity,
  RoomPrice,
  RoomSize as RoomSizeType,
  URLSearchQuery,
} from 'Common-Types';
export type Props = {
  roomName: string;
  query?: URLSearchQuery;
  price: RoomPrice;
  points: Points | null;
  containerClassName?: string;
  features: FeatureGroup[];
  roomSize?: RoomSizeType;
  capacity?: RoomCapacity;
  availabilityCount?: number;
  navigateTo: string;
  isSP: boolean;
  hasMeal: HasMeal;
  departureStation?: string;
  destinationStation?: string;
};

const RoomInfo = (props: Props) => {
  const {
    roomName,
    price,
    availabilityCount,
    points,
    features,
    roomSize,
    capacity,
    isSP,
    navigateTo,
    query,
    hasMeal,
    departureStation,
    destinationStation,
  } = props;

  const { adultCount, childCount, noOfDays, stayNights } = parseSearchQuery(query);

  return (
    <div
      className={isSP ? styles.roomContainer : styles.roomContainerPC}
      data-testid="roomInfo-wrapper"
    >
      <div className={styles.features}>
        {roomName && (
          <h4 className={styles.roomNameWrapper}>
            <Link className={styles.roomName} data-testid="roomInfo-roomName" to={navigateTo}>
              <span>{roomName}</span>
              {isSP && <ArrowRight size={24} color="darkCyan" className={styles.arrowRight} />}
            </Link>
          </h4>
        )}
        <ItemFeatures
          features={features}
          roomSize={roomSize}
          capacity={capacity}
          hasMeal={hasMeal}
          className={styles.hotelFeatures}
          isDisplayPaymentMethod
        />
      </div>
      <PriceInfo
        price={price}
        adultCount={adultCount}
        numberOfChildren={childCount}
        noOfDays={noOfDays}
        stayNights={stayNights}
        departureStation={departureStation}
        destinationStation={destinationStation}
        selectButtonText={!isSP && <Translate id="Hotel_List.List.Select_Hotel" />}
        points={points}
        roomCount={availabilityCount}
        className={styles.priceInfo}
        onSelectUrl={navigateTo}
      />
    </div>
  );
};

export default RoomInfo;
